module.exports = __webpack_public_path__ + "static/media/list.840754fe.svg";